import { useMemo } from 'react';

import { useMethodistGroupOptionsQuery } from 'core/graphql';

import { transformMethodistGroupOptions, IMethodistGroupOptions } from './transform';

type methodistGroupOptionsType = IMethodistGroupOptions & {
  loading?: boolean;
  error?: string;
};

export const useMethodistGroupOptions = (isMethodist: boolean): methodistGroupOptionsType => {
  const { data, loading, error } = useMethodistGroupOptionsQuery({
    fetchPolicy: 'cache-first',
    skip: !isMethodist,
  });

  const { courseOptions, groupOptions } = useMemo(
    () => transformMethodistGroupOptions(data),
    [data],
  );

  return {
    courseOptions,
    groupOptions,
    loading,
    error: error?.message || '',
  };
};
